// store/loaderSlice.ts
import { createSlice } from '@reduxjs/toolkit';

const loaderSlice = createSlice({
  name: 'loader',
  initialState: {
    loadingCount: 0,
    isLoading:false
  },
  reducers: {
    showLoader: (state) => {
      state.loadingCount += 1;
      state.isLoading=true
    },
    hideLoader: (state) => {
      state.loadingCount = Math.max(0, state.loadingCount - 1);
      state.isLoading=false
    },
  },
});

export const { showLoader, hideLoader } = loaderSlice.actions;

export const selectIsLoading = (state: { loader: { loadingCount: number } }) =>
  state.loader.loadingCount > 0;

export default loaderSlice.reducer;
